// @flow
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import MaterialUIIconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';

type Classes = {
    buttonWrapper: string
}

type ProvidedProps = {
    classes: Classes
}

type Props = {
    children: Node,
    disabled?: boolean,
    onClick?: Function,
    title?: string,
    disabledTitle?: string,
    className?: string,
};

const styles = () => ({
    buttonWrapper: {
        display: 'inline-flex'
    }
});

const IconButton = (props: Props & ProvidedProps) => {

    const button = (
        <MaterialUIIconButton
            onClick={props.onClick}
            disabled={props.disabled}
            className={props.className}
        >
            {props.children}
        </MaterialUIIconButton>
    );

    const title = (props.disabled && props.disabledTitle) ? props.disabledTitle : props.title;

    return (
        <React.Fragment>
            {
                (title) ? (
                    <Tooltip title={title}>
                        <div
                            className={props.classes.buttonWrapper}
                        >
                            { button }
                        </div>
                    </Tooltip>
                ) : (
                    button
                )
            }
        </React.Fragment>
    );
}

export default withStyles(styles)(IconButton);
